export const amazon = {
  authSuccess: "Seller Central App wurde erfolgreich autorisiert",
  oAuthFlowHelp: "Amazon Seller Central App autorisieren",
  region: "Seller Central Region",
  migrationSuccess: "Erfolgreich Token aus Amazon übernommen.",
  activateReceiptTitle: "Rechnungsservice aktivieren?",
  activateReceiptIntro:
    "Ab dem nächsten Speichern erstellt und synchronisiert Xentral Rechnungen automatisch mit deinem Verkaufskanal.",
  activateReceiptConfirm:
    "Bestätige, dass du den Rechnungsservice im alten Shopimporter (Legacy) abgeschaltet hast.",
  activateReceiptWarning:
    "Bleibt er an beiden Stellen aktiv, entstehen doppelte oder falsche Rechnungen.",
  activateReceiptInstruction:
    "So deaktivierst du den Rechnungsservice im alten Shopimporter: Stelle das Invoice Handling auf None/Amainvoice.",
  activateReceiptOpenLegacy: "Alten Shopimporter öffnen",
  activateReceiptOpenHandbook: "Zur Anleitung im Handbuch",
  activateReceiptHandbookUrl:
    "https://help.xentral.com/hc/de/articles/25769333725596-Amazon-Workflows-konfigurieren",
  activateReceiptChecking: "Status des alten Shopimporters wird geprüft …",
  activateReceiptLegacyStillActive:
    "Der alte Shopimporter (Verkaufskanal) ist noch aktiv. Deaktiviere ihn zuerst, bevor du den Rechnungsservice aktivierst.",
  activateReceiptCheckFailed:
    "Der Status des alten Shopimporters konnte nicht geprüft werden. Bitte versuche es erneut."
};
